import { useEffect, useState } from "react";

export default function ConfirmModal({ message, onConfirm, onCancel }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile(); // Verifica inicialmente
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Estilos dinâmicos baseados no tipo de dispositivo
  const modalStyles = {
    background: "white",
    padding: isMobile ? "16px" : "20px",
    borderRadius: "10px",
    maxWidth: isMobile ? "80%" : "600px",
    maxHeight: "80vh",
    overflowY: "auto",
    textAlign: "left",
    width: isMobile ? "100%" : "auto",
  };

  const buttonStyles = {
    padding: "8px 16px",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    width: isMobile ? "100%" : "auto",
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "10px" : 0,
      }}
    >
      <div style={modalStyles}>
        {Object.entries(message).map(([label, value], index) => (
          <div key={index} style={{ marginBottom: "16px" }}>
            <div style={{ fontWeight: "bold", marginBottom: "4px" }}>{label}:</div>
            <div style={{ whiteSpace: "pre-wrap" }}>{value}</div>
          </div>
        ))}

        <div
          style={{
            marginTop: "20px",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              ...buttonStyles,
              backgroundColor: "#dc3545", // vermelho
            }}
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            style={{
              ...buttonStyles,
              backgroundColor: "#28a745", // verde
            }}
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
}
